export function parseQueryString(queryStr) {
    var queryString = {},
        parts,
        i,
        item;

    if (typeof queryStr === 'undefined' || queryStr === null) {
        return queryString;
    }

    parts = queryStr
        .split('?')
        .pop()
        .split('&');
    i = parts.length;

    while (i--) {
        item = parts[i].split('=');
        queryString[item[0]] = decodeURI(item[1]);
    }

    return queryString;
}
